// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCheck: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="#00A65A"
                d="M7.8515625,4.1015625 L5.25,6.70546889 L4.12734389,5.6015625 C3.90761733,5.38183594 3.55171895,5.38183594 3.33187509,5.6015625 C3.11203122,5.82128906 3.11214852,6.17718744 3.33187509,6.39703131 L4.83187509,7.89703131 C4.96171868,8.00859404 5.10468757,8.0625 5.25,8.0625 C5.39531243,8.0625 5.53781247,8.00756264 5.6477344,7.8977108 L8.6477344,4.8977108 C8.86746097,4.67798424 8.86746097,4.32208586 8.6477344,4.10224199 C8.42800784,3.88239813 8.07187486,3.88359404 7.8515625,4.1015625 Z M6,0 C2.68593764,0 0,2.68593764 0,6 C0,9.31406236 2.68593764,12 6,12 C9.31406236,12 12,9.31406236 12,6 C12,2.68593764 9.31406236,0 6,0 Z M6,10.875 C3.31171882,10.875 1.125,8.68804693 1.125,6 C1.125,3.31195307 3.31171882,1.125 6,1.125 C8.68828154,1.125 10.875,3.31195307 10.875,6 C10.875,8.68804693 8.68828154,10.875 6,10.875 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(IconCheck);
